import React from 'react';

// Types
import { UpdateAiReportType } from 'Shared/types/UpdateAiReportType.type';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';
import ReportListItem from './ReportListItem';

// Styles
import './ReportsList.scss';

type Props = {
  reports: UpdateAiReportType[];
  isFetching: boolean;
};

const ReportsList = ({ reports, isFetching }: Props) => {
  const baseClassName = 'ReportsList';
  return (
    <div className={baseClassName}>
      {reports.map(report => (
        <ReportListItem key={report.slug} report={report} />
      ))}
      {isFetching && (
        <>
          <WpContainer className={`${baseClassName}__loading-item`}>
            <WpContainerBody>
              <div className={`${baseClassName}__loading-item__date`}>
                <LoadingShimmer shape="rectangle" height="14px" width="55%" />
              </div>
              <div className={`${baseClassName}__loading-item__title`}>
                <LoadingShimmer shape="rectangle" height="18px" width="70%" />
              </div>
            </WpContainerBody>
          </WpContainer>
          <WpContainer className={`${baseClassName}__loading-item`}>
            <WpContainerBody>
              <div className={`${baseClassName}__loading-item__date`}>
                <LoadingShimmer shape="rectangle" height="14px" width="55%" />
              </div>
              <div className={`${baseClassName}__loading-item__title`}>
                <LoadingShimmer shape="rectangle" height="18px" width="70%" />
              </div>
            </WpContainerBody>
          </WpContainer>
        </>
      )}
    </div>
  );
};

export default ReportsList;
